import React from 'react';
import css from './WisdomCard.module.css';
import { IconBrandCard } from '../../../../components';
import moment from 'moment';

function WisdomCard(props) {
  const {
    wisdomImage,
    wisdomDate,
    wisdomTitle,
    wisdomDescription,
    wisdomProfile,
    locationFlag,
    locationName,
    name,
    activeTab,
    abbreviatedName,
  } = props;
  return (
    <div className={css.wisdomCard}>
      <div className={css.wisdomImage}>
        <img src={wisdomImage} />
      </div>
      <div className={css.wisdomBody}>
        <div className={css.wisdomDate}>
          <IconBrandCard type="calender" />
          {moment(wisdomDate).format('ll')}
        </div>
        <div className={css.wisdomTitle}>{wisdomTitle}</div>
        <div
          className={css.wisdomDescription}
          dangerouslySetInnerHTML={{ __html: wisdomDescription }}
        ></div>
        {activeTab !== 3 && (
          <div className={css.cardHead}>
            <div className={css.cardImage}>
              {wisdomProfile ? (
                <img src={wisdomProfile} />
              ) : (
                <span className={css.abbreviatedName}>{abbreviatedName}</span>
              )}
            </div>
            <div>
              <div className={css.name}>{name}</div>

              {/* {locationName && locationFlag && (
                <div className={css.location}>
                  <img src={locationFlag} />
                  <span className={css.locationName}>{locationName}</span>
                </div>
              )} */}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default WisdomCard;
